import { TimesHttpHelper, NO_DATA_MESSAGE } from "@usas/ui-web/utils/HttpHelper";

const deleteTimeRecordsRunLog = (processType, state, setState) => {
  if (state.isArrayLoading !== true && !state.message) {
    let newState = {
      ...state,
      isArrayLoading: true,
      isArrayLoaded: false,
      message: 'Loading...'
    };
    setState(newState);

    const url = `/TimeCalculation/DeleteTimeRecordsRunLog/${processType}`;
    TimesHttpHelper(url, 'DELETE')
      .then((arrayData) => {
        if (!arrayData) {
          throw new Error(NO_DATA_MESSAGE);
        } else {
          setState({
            ...newState,
            isArrayLoading: false,
            isArrayLoaded: true,
            arrayData,
            message: ''
          });
        }
      })
      .catch((e) => {
        const message = e && e.message ? e.message : NO_DATA_MESSAGE;
        setState({
          ...newState,
          isArrayLoaded: false,
          isArrayLoading: false,
          message: message
        });
      });
  };
};

export default deleteTimeRecordsRunLog;